import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '@config/api.config';
import {ACCOUNTS_SERVICE, ACCOUNTS_SERVICE_API_VERSION} from '@constants/api.constants';
import {ApiResponse} from '@core/models/api-response.model';
import {LoginData, LoginRequest, ForgotPasswordRequest} from '@core/models/auth.model';
import {endpoint} from '@constants/path.constants';


@Injectable({providedIn: 'root'})
export class AccountsWebservices {
  private readonly baseUrl = ApiConfig.getBaseUrl(ACCOUNTS_SERVICE, ACCOUNTS_SERVICE_API_VERSION);

  constructor(private http: HttpClient) {
  }

  private get headers(): HttpHeaders {
    return new HttpHeaders(ApiConfig.secretKeyHeader());
  }

  verifyUser(payload: {}) {
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.account.verify_user, payload, {headers: this.headers}
    );
  }

  login(payload: LoginRequest) {
    return this.http.post<ApiResponse<LoginData>>(
      this.baseUrl + endpoint.account.login, payload, {headers: this.headers}
    );
  }

  forgotPassword(payload: ForgotPasswordRequest) {
    return this.http.post<ApiResponse<null>>(
      this.baseUrl + endpoint.account.forgot_password, payload, {headers: this.headers}
    );
  }
}
